import React from 'react';
import PolicyManager from '../PolicyManager';

// 약관 버전 관리
const EULA_POLICY_VERSIONS = {
  'ko': {
    current: '2024.02.20', // 현재 버전
    versions: {
      '2024.02.20': () => import('./versions/ko_20240220.js'),
    }
  },
  'en': {
    current: '2024.02.20',
    versions: {
      '2024.02.20': () => import('./versions/en_20240220.js'),
    }
  }
};

const EulaPolicyManager = ({ language = 'ko', version, onVersionChange }) => {
  return (
    <PolicyManager
      language={language}
      version={version}
      onVersionChange={onVersionChange}
      policyVersions={EULA_POLICY_VERSIONS}
      policyName="EULA"
    />
  );
};

export default EulaPolicyManager; 